module.exports = __webpack_public_path__ + "img/about-image.5bea181a.jpg";